import {
  FETCH_ALL_CATEGORIES,
  FETCH_ONE_CATEGORY,
  DELETE_CATEGORY
} from "../constants/ActionTypes";

const INITIAL_STATE = {
  all_categories: null,
  current_category: null,
  isFetching: false,
  error: null
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_ALL_CATEGORIES:
      return { ...state, all_categories: action.payload };
    case FETCH_ONE_CATEGORY:
      return { ...state, current_category: action.payload };
    case DELETE_CATEGORY:
      // Remove the deleted category from all_categories if it exists
      const updatedCategories = state.all_categories
        ? state.all_categories.filter(category => category.category_id !== action.payload)
        : null;

      // Clear current_category if it was the deleted one
      const currentCategory = state.current_category?.category_id === action.payload
        ? null
        : state.current_category;

      return {
        ...state,
        all_categories: updatedCategories,
        current_category: currentCategory
      };
    default:
      return state;
  }
}
